angular
.module('inkfinder')

// Global loading bar config
.config(function(cfpLoadingBarProvider) {
  cfpLoadingBarProvider.latencyThreshold = 300;
  cfpLoadingBarProvider.includeSpinner = false;
})

// Intercom configuration
// .config(function($intercomProvider, INTERCOM_APPID) {
//   $intercomProvider
//     .appID(INTERCOM_APPID);
//   $intercomProvider.asyncLoading(true);
// })

// Stripe config.
// .config(function(stripeProvider) {
  // Stripe key
  // stripeProvider.setPublishableKey('pk_test_eQS565yugdj2oZewaD7puTL4');
// })

// Add the Auth Inerceptor as a HTTP Provider Interceptor.
.config(function($httpProvider) {
  $httpProvider.interceptors.push('AuthInterceptor');
})

// Lightbox gallery config
.config(function(LightboxProvider) {
  LightboxProvider.getImageUrl = function(image) {
    return image.image_1024;
  };
})

// Satellizer config
.config(function($authProvider, ENDPOINT, APP) {
  $authProvider.facebook({
    clientId: APP.facebook,
    url: ENDPOINT.server + 'collectors/api/v1.1/auth/facebook/'
  });

  $authProvider.loginUrl = ENDPOINT.server + 'collectors/api/v1.1/login/';
  $authProvider.signupUrl = ENDPOINT.server + 'collectors/api/v1.1/';
})

// ui router config
.config(function(
  $urlServiceProvider,
  $locationProvider,
  DEFAULT_STATES
) {
// Use the HTML5 History API
  $locationProvider.html5Mode(true);

  // Trailing slashes are not required
  $urlServiceProvider.config.strictMode(false);

  // Set the default state if no states match the URL entered
  $urlServiceProvider.rules.when('', DEFAULT_STATES.public);

  // Set the default state if no states match the URL entered
  $urlServiceProvider.rules.otherwise(DEFAULT_STATES.public);
});



// WEBPACK FOOTER //
// ./app.config.js